import React, { Component } from 'react'
import { Input } from 'antd'
import styles from './index.module.less'

export default class SearchBar extends Component {
  render() {
    const Search = Input.Search;
    return (
      <div className={styles.searchWrapper}>
        <Search
          placeholder="全站搜索"
          enterButton="搜索"
          size="large"
          onSearch={value => console.log(value)}
        />
        <div className={styles.hotword}>
          <span>搜索热词: </span>
          <a>流量限制</a>
          <a>API调用示例</a>
          <a>接入指南</a>
        </div>
      </div>
    )
  }
}